<template>
    <div>
        <div class="dfjc">
            <el-input
                    prefix-icon="el-icon-search"
                    placeholder="输入关键字进行查找品种"
                    v-model="search"
            @change="searchbtn">
            </el-input>
<!--            <el-button icon="el-icon-search" circle @click="searchbtn" style="margin-left: 20px"></el-button>-->
        </div>
        <div class="hisbox">
            <span v-for="(item,index) in historyData" :key="index+'h'" @click="his(item)" class="hiscss">{{item}}</span>
        </div>
        <div class="con" :style="'height:'+tableHeight+'px'">
            <div v-for="(item,index) in pzdata" :key="index">
                <el-checkbox v-model="pzid" :label="item.id" @change="choosepz(item)" style="padding: 5px 0;">
                    {{item.name+' '+item.specification+' '+item.place+' '+item.producer+' '+item.unit}}
                </el-checkbox>
            </div>

        </div>
        <el-pagination  style="margin-top: 10px;text-align: right"
                              background
                              @current-change="pageCurrentChange"
                              layout="total,prev, pager, next"
                              :current-page.sync="currentPage"
                              :total="total"
                              :page-size="pageSize">
    </el-pagination>
        <div class="center"style="margin-top: 15px;">
            <el-button @click="save" :class="baseerp+'btn'" size="mini">
                {{$t('button_confirm')}}
            </el-button>
        </div>


    </div>
</template>

<script>
    import * as API from "../api"
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "PzList",
        components: {},
        data() {
            return {
                pzdata: [],
                search:'',
                pzid:[],
                baseerp:'',
                pzitem:[],
                currentPage:1,
                pageSize:12,
                total:0,
                historyData:[],
                tableHeight:0,
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            if (JSON.parse(localStorage.getItem('pzHistory'))){
                this.historyData=JSON.parse(localStorage.getItem('pzHistory'))
            }
            this.baseerp=baseerp;
            this.dict()
            this.$nextTick(()=>{
                this.onResize();

            })
            // this.baseerp=baseerp;
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-25

                // console.log(this.tableHeight)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            searchbtn(){
                if (this.search!=''){
                    if(this.historyData.includes(this.search)){
                        let i=this.historyData.indexOf(this.search);
                        this.historyData.splice(i,1);
                    }
                    if (this.historyData.length>20){
                        this.historyData.splice(0,20);
                    }
                    this.historyData.unshift(this.search);
                    localStorage.setItem('pzHistory',JSON.stringify(this.historyData));
                }
                this.currentPage=1
                this.dict()
            },
            his(name){
                this.currentPage=1
                this.search=name
                this.dict()
            },
            async dict(){
                // console.log(resolve,'resolve',val)
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id);
                } else {
                    this.mid = sessionStorage.getItem('mids');
                }
                let param={
                    i_mid: this.mid,
                    type:4,
                    i_pid:0,
                    keyword:this.search,
                    currentPage:this.currentPage,
                    pageSize:this.pageSize
                };
                let res=await API.dict(param);
                if ( res.code == 1 ){
                    this.pzdata=res.data.list
                    this.total=res.data.total
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.dict();
            },
            choosepz(val){

                let i=this.pzitem.find(item=>item.pzId==val.id);
                if (i){
                    this.pzitem.splice(i,1)
                }else{
                    let obj={
                        unit:val.unit,
                        id:0,
                        specification:val.specification,
                        pzId:val.id,
                        pzName:val.name,
                        detailType:1,
                        place:val.place,
                        producer:val.producer,
                        num:'',
                    }
                    this.pzitem.push(obj)
                }
                // console.log(i,'i',val,'val',this.pzitem)
            },
            save(){
                this.$emit('close',this.pzitem)
            }
        },
    }
</script>

<style lang="scss" scoped>
    .dfjc{
        display: flex;
        justify-content: space-between
    }
    .con{
        /*height: 500px;*/
        overflow-y: auto;
    }
    .center{
        text-align: center;
    }
    .hiscss{
        display: inline-block;
        padding: 3px 5px;
        background-color: #b2b2b2;
        color: white;
        font-size: 12px;
        border-radius: 6px;
        margin: 3px;
    }
    .hisbox{
        min-height: 29px;
        margin-top: 3px;
    }
</style>